<template>
	<v-rating v-model="ratingModel" :name="id" :readonly="readonly" hover density="comfortable" class="global-rating">
		<template #item="props">
			<GlobalIcon
				class="global-rating__icon"
				:class="{
					'global-rating__icon--filled': colorFilled && (props.isFilled || props.isHovered),
					'global-rating__icon--empty': colorEmpty && !props.isFilled && !props.isHovered,
				}"
				:name="setIcon(props.isFilled, props.isHovered)"
				:height="16" />
		</template>
	</v-rating>
</template>

<script setup lang="ts">
const id = useId()
const ratingModel = ref(0)

const prop = withDefaults(
	defineProps<{
		rating?: number | string
		colorFilled?: string
		colorEmpty?: string
		readonly?: boolean
	}>(),
	{
		colorFilled: 'var(--primary-color)',
		colorEmpty: 'var(--primary-color)',
	},
)

const setIcon = (isFilled: boolean, isHovered?: boolean) => {
	if (prop.readonly && prop.rating === 0) return 'star-empty-color'
	return isFilled ? 'star-icon-color' : isHovered ? 'star-icon-color' : 'star-empty-color'
}

const pointerEvents = computed(() => {
	return prop.readonly ? 'none' : 'auto'
})

const emit = defineEmits<{
	(e: 'updateRating', value: number): void
}>()

watchEffect(() => {
	ratingModel.value = Math.round(prop.rating)
})

watchEffect(() => {
	if (ratingModel.value !== prop.rating) {
		emit('updateRating', ratingModel.value)
	}
})
</script>

<style lang="scss" src="./Rating.scss"></style>
<style lang="scss">
.global-rating__icon {
	pointer-events: v-bind(pointerEvents);
}
.global-rating__icon--filled {
	color: v-bind(colorFilled);
}
.global-rating__icon--empty {
	color: v-bind(colorEmpty);
}
</style>
